import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import GtmInboxPage from '@/pages/gtm-workspace/inbox'
import { requireGtmWorkspace } from '@/shared/lib/gtm-route-guard'

const searchSchema = z.object({
  project: z.string().uuid().optional(),
  lead: z.string().uuid().optional(),
  // Accepted for old links; Inbox is one list now.
  box: z.enum(['sent']).optional().catch(undefined),
})

export const Route = createFileRoute('/$lang/workspace/$workspaceId/gtm/inbox')(
  {
    validateSearch: (search) => searchSchema.parse(search),
    beforeLoad: ({ context, params }) => requireGtmWorkspace(context, params),
    component: GtmInboxPage,
    staticData: { layout: 'main' },
  },
)
